export default {
    SET_HISTORY: 'SET_HISTORY',
  };